const environmntConfig = {   
    
    setEnvironmentURLs(environment, hostname) {
        let env = {};
        if(environment.env === "prod-"){
            env.appURL = "https://fixmystation.belgiantrain.be/"
            env.backendURL= "https://fixmystation.api.intern-belgiantrain.be/api/"
            env.existingAppURL= "https://fixmystation.belgiantrain.be/"
            env.redirectURI = "https://fixmystation.belgiantrain.be/callback"
            env.clientID = environment.clientID
            env.authorityOIDC = "https://idp.intern-belgianrail.be/idhub/oidc/.well-known/openid-configuration"
            env.metadataOIDC = "https://idp.intern-belgianrail.be/idhub/oidc"
            env.apiKey = environment.apiKey
            env.plannedMaintenance = environment.plannedMaintenance

        }else{
            env.appURL = "https://fixmystation."+environment.env+"belgiantrain.be/"
            env.backendURL= "https://fixmystation.api."+environment.env+"intern-belgiantrain.be/api/"
            env.existingAppURL= "https://fixmystation."+environment.env+"belgiantrain.be/"
            env.redirectURI = "https://fixmystation."+environment.env+"belgiantrain.be/callback"
            env.clientID = environment.clientID
            env.authorityOIDC = "https://idp.acc-intern-belgianrail.be/idhub/oidc/.well-known/openid-configuration"
            env.metadataOIDC = "https://idp.acc-intern-belgianrail.be/idhub/oidc"
            env.apiKey = environment.apiKey
            env.plannedMaintenance = environment.plannedMaintenance
        }
      
        console.log(env.appURL);
        console.log(env.backendURL);
        console.log(env.existingAppURL);
        console.log(env.redirectURI);
        console.log(env.clientID);

        if(hostname.includes("localhost")){
            // Only for localhost
            env.customToken=true;
            env.code="ZxJ1gwuQl5IBCyvcetZ-E4m_rSixTyDh29bG3j-uWO_mM-8U8nqhrw"
            env.state="7b1e26da8d03487bad8d8647c16c73b0"
            env.IdentityToken=""
            env.refreshToken=""
            env.language="en-GB"
            env.apiKey = "FMS-v0001-20230904-sk38njd38SDK359msfdnU20KDb3edm0237Dbwjff"
            env.plannedMaintenance = "false"

        }
        return env;  
        
    }
  };

  
const hostname = window && window.location && window.location.hostname;
    let environment = {env: "", backednEnv: "", clientID: process.env.REACT_APP_CLIENT_ID_PROD, idpEnv: "" };
if(hostname.includes("localhost") || hostname.includes("dev-")){
    environment.env = "dev-";
    environment.backednEnv = "dev-";
    environment.idpEnv = "acc-";
    environment.clientID = process.env.REACT_APP_CLIENT_ID_DEV;
    environment.apiKey = process.env.REACT_APP_API_KEY_DEV;
} else if(hostname.includes("tst-")){
    environment.env = "tst-";
    environment.backednEnv = "tst-";
    environment.idpEnv = "acc-";
    environment.clientID = process.env.REACT_APP_CLIENT_ID_TST;
    environment.apiKey = process.env.REACT_APP_API_KEY_TST;

} 
else if(hostname.includes("acc-")){
    environment.env = "acc-";
    environment.backednEnv = "acc-";
    environment.idpEnv = "acc-";
    environment.clientID = process.env.REACT_APP_CLIENT_ID_ACC;
    environment.apiKey = process.env.REACT_APP_API_KEY_ACC;

}else {
    environment.env = "prod-";
    environment.backednEnv = "prod-";
    environment.idpEnv = "prod-";
    environment.clientID = process.env.REACT_APP_CLIENT_ID_PROD;
    environment.apiKey = process.env.REACT_APP_API_KEY_PROD;

}


const envConfig = environmntConfig.setEnvironmentURLs(environment, hostname);
export default envConfig;